/** @format */

import React from 'react';
import { connect } from 'react-redux';
import CasesManagerStatusPres from 'src/ui/features/Cases/presentational/CasesManagerStatusPres';
import { setCaseManagerStatus } from 'src/services/cases.service';
import { splCharValidation} from "src/helpers";

class CasesManagerStatusContainer extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      caseStatusId: props.caseStatusId,
      reasonForStatusChange: props.reasonForStatusChange,
      isError: false,
      disableUpdate: false,
    };
  }

  handleCaseStatusChange = caseStatusId => {
    this.setState({ caseStatusId: caseStatusId, isError: false });
  };

  handleOtherReasonChange = reasonForStatusChange => {
    const {allowedSpecialChars="\"/)”“‘’'(£!+$%-_.,;@?:*= &–€", additionalCharRestict=["÷", "₹", "¥", "₩", "#","^","~","<",">","|","{","}","\\[","\\]"]}= this.props;
    console.log(this.props);
    if(this.state.isError){
      if(splCharValidation(reasonForStatusChange, allowedSpecialChars, additionalCharRestict)){
        this.setState({ reasonForStatusChange: reasonForStatusChange, isError: true });
      }else{
        this.setState({reasonForStatusChange: reasonForStatusChange, isError: false});
      }
    }else{
      this.setState({ reasonForStatusChange: reasonForStatusChange, isError: false  });
    }

    // this.setState({ reasonForStatusChange: reasonForStatusChange, isError: false });
  };

  handleUpdate = async () => {
    this.setState({ disableUpdate: true });
    const { onRefreshDetails, caseManagerId } = this.props;
    let { caseStatusId, reasonForStatusChange } = this.state;
    if (caseStatusId === 3 && (reasonForStatusChange === null || reasonForStatusChange.length == 0)) {
      this.setState({ isError: true, disableUpdate: false });
      return;
    }

    if (caseStatusId !== 3) {
      this.setState({ isError: false, reasonForStatusChange: '' });
      reasonForStatusChange = '';
    }

    const result = await setCaseManagerStatus(caseManagerId, caseStatusId, reasonForStatusChange);

    if (result && result.success) {
      if (onRefreshDetails) await onRefreshDetails();
    }
    this.setState({ disableUpdate: false });
  };

  splCharValidationCheck=(event) => {
    const {allowedSpecialChars="\"/)”“‘’'(£!+$%-_.,;@?:*= &–€", additionalCharRestict=["÷", "₹", "¥", "₩", "#","^","~","<",">","|","{","}","\\[","\\]"]}= this.props;

    if(splCharValidation(event.target.value, allowedSpecialChars, additionalCharRestict)){
      this.setState({ isError: true });
    }else{
      this.setState({ isError: false });
    }
  };

  render() {
    return (
      <CasesManagerStatusPres
        caseStatusId={this.state.caseStatusId}
        statusList={this.props.statusList}
        reasonForStatusChange={this.state.reasonForStatusChange}
        handleCaseStatusChange={this.handleCaseStatusChange}
        handleOtherReasonChange={this.handleOtherReasonChange}
        onUpdate={this.handleUpdate}
        isError={this.state.isError}
        disableUpdate={this.state.disableUpdate}
        checkSplCharValidation={this.splCharValidationCheck}
        allowedValidationSpecialChars={this.props.allowedValidationSpecialChars}
      />
    );
  }
}

const mapStateToProps = state => ({});
const mapDispatchToProps = {};

export default connect(mapStateToProps, mapDispatchToProps)(CasesManagerStatusContainer);
